import "./App.css";
import "./sass/main.scss";
import Router from "./routing/Router";

function App() {
  return <Router />;
}

export default App;
